export function createContextValueWarningProxy<T extends object>(contextName: string) {
  return new Proxy<T>({} as unknown as T, {
    get(_, property: string) {
      if (typeof globalThis === "undefined") return; // Prevent server side render will throw error
      throw new Error(
        `You must implement the ${property} by wrapping the component inside <${contextName}.provider value={{${property}}} />`,
      );
    },
  });
}
